import { withStandardGetHook } from '@spotify/confidence-graphql';
// Import generated types and hooks from the graphql package
import {
  FactTableQuery,
  FactTableQueryVariables,
  FactTableWithWarehouseFragment,
  FactTablesDocument,
  useFactTableQuery,
  useOnFactTableCreatedSubscription,
  useOnFactTableUpdatedSubscription,
} from '@spotify/confidence-graphql';

const useFactTableImpl = withStandardGetHook<
  FactTableQuery,
  FactTableWithWarehouseFragment,
  'factTable',
  FactTableQueryVariables
>(useFactTableQuery, 'factTable');

export const useFactTable: typeof useFactTableImpl = options => {
  useOnFactTableCreatedSubscription({
    onData: _options => {
      _options.client.refetchQueries({
        include: [FactTablesDocument],
      });
    },
    skip: options.skip,
  });

  useOnFactTableUpdatedSubscription({
    skip: options.skip,
  });

  return useFactTableImpl(options);
};
